module.exports = __webpack_public_path__ + "img/2Installation.32003026.png";